import src from "IMAGE";
export default { src, width: 256, height: 256, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAKElEQVR42rWKsQ0AAAQEf1R0mMIAdha9RPWXXHUH8FGTivS+3PYPfAZ5BBwVLpahGgAAAABJRU5ErkJggg=="};
